<!--
Copyright (C) 2026 Checkmk GmbH - License: Checkmk Enterprise License
This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
conditions defined in the file COPYING, which is part of this source code package.
-->

<script setup lang="ts">
import AiMarkdown from '@/nonfree/ai/AiMarkdown.vue'

import type { Block } from './block'

defineProps<{ block: Block<'thinking' | 'tool_use' | 'tool_result'> }>()
</script>

<template>
  <div class="ai-block-aside">
    <AiMarkdown v-if="block.type === 'thinking'" :text="block.thinking" />
    <template v-else-if="block.type === 'tool_use'">
      {{ block.name }} {{ JSON.stringify(block.input) }}
    </template>
    <template v-else>{{ block.content }}</template>
  </div>
</template>

<style scoped>
.ai-block-aside {
  font-size: 0.9em;
  color: var(--font-color-dimmed);
}
</style>
